var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFiletype(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.151 19.238 1.494 2.31H55.766a2.596 2.596 0 0 1 2.593 2.594v28.53a2.596 2.596 0 0 1-2.593 2.595h-41.5a2.596 2.596 0 0 1-2.594-2.594V16.36a2.596 2.596 0 0 1 2.594-2.593H24.64l3.51 5.471z",
    fill: "#000",
    stroke: "#fff",
    strokeWidth: 2.594
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.734 15.063a9.076 9.076 0 0 1 9.079 9.079v38.906a9.076 9.076 0 0 1-9.079 9.078H14.266a9.076 9.076 0 0 1-9.079-9.078V16.36a9.076 9.076 0 0 1 9.079-9.078h13.662l5.188 7.781h35.618z",
    fill: "#9F77ED"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.266 9.876A6.482 6.482 0 0 0 7.78 16.36v46.688a6.482 6.482 0 0 0 6.485 6.484h54.468a6.482 6.482 0 0 0 6.485-6.484V24.142a6.482 6.482 0 0 0-6.485-6.485H31.728L26.54 9.876H14.266z",
    fill: "#F5F5FD"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.266 9.876A6.482 6.482 0 0 0 7.78 16.36s.011-5.925 0 8.989c0 0 67.438.078 67.438 0v-1.207a6.482 6.482 0 0 0-6.485-6.485H31.728L26.54 9.876H14.266z",
    fill: "#DBD3ED"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9F77ED",
    d: "M7.781 24.142h67.438v2.594H7.781z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiletype);
export default __webpack_public_path__ + "static/media/Filetype.7d1ed09fe5036822450efb57cb4fe5e4.svg";
export { ForwardRef as ReactComponent };